<template>
  <li class="c-facet" :class="{ disabled: !checked && !facetValue.count }">
    <router-link :to="buildQuery(newQuery)" class="c-facet__link">
      <div class="c-facet__link--content">
        <div class="custom-control custom-checkbox">
          <input
            :id="facetValue.value"
            type="checkbox"
            class="custom-control-input"
            :checked="checked"
          />

          <label
            class="custom-control-label d-flex align-items-center"
            :for="facetValue.value"
          >
            <img
              v-if="thumbnailWithCrops"
              :src="thumbnailWithCrops"
              :height="imageDimensions.height"
              :width="imageDimensions.width"
              class="c-facet__image"
            />
            <span class="c-facet__link--label">
              {{ facetValue.value }}{{ unit }}
              <i class="text-muted">({{ facetValue.count }})</i>
            </span>
          </label>
        </div>
      </div>
    </router-link>

    <tooltip v-if="tooltip" :tooltip="tooltip" />
  </li>
</template>

<script>
import tooltip from './tooltip.vue';
import { mapGetters, mapState } from 'vuex';

export default {
  components: { tooltip },
  props: {
    facetValue: {
      type: Object,
      required: true,
      count: {
        type: Number,
        required: true
      },
      metadata: {
        type: Object,
        required: true
      },
      value: {
        type: String,
        required: true
      }
    },
    facetKey: {
      type: String,
      required: true
    },
    unit: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      imageDimensions: {
        height: 25,
        width: 25
      }
    };
  },
  computed: {
    ...mapGetters('productSearch', ['buildQuery', 'isFilterActive']),
    ...mapState(['culture']),
    ...mapState('productSearch', ['query']),
    checked() {
      return this.isFilterActive(this.facetKey, this.facetValue.value);
    },
    fileNameAndExtension() {
      return this.facetValue.imageName.split('/').pop();
    },
    thumbnailWithCrops() {
      if (this.facetValue.metadata.thumbnail)
        return `${this.facetValue.metadata.thumbnail}?width=${this.imageDimensions.width}&height=${this.imageDimensions.height}&format=webp`;
      return undefined;
    },
    tooltip() {
      if (
        this.facetValue.metadata.title ||
        this.facetValue.metadata.description ||
        this.facetValue.metadata.imageName ||
        this.facetValue.metadata.url
      ) {
        return {
          title: this.facetValue.metadata.title,
          description: this.facetValue.metadata.description,
          imageName: this.facetValue.metadata.imageName,
          url: this.facetValue.metadata.url
        };
      }
      return undefined;
    },
    newQuery() {
      const newQuery = {
        page: 1
      };
      newQuery[this.facetKey] = this.facetValue.value;
      return newQuery;
    }
  },
  watch: {
    checked() {
      document.getElementById('products-overview').scrollIntoView();
    }
  }
};
</script>

<style lang="scss">
@import '@/css/src/utilities/_variables.scss';
@import '@/css/src/utilities/_mixins.scss';
@import '~bootstrap/scss/mixins';

.c-facet {
  display: flex;
  flex: 1;

  &.disabled {
    opacity: 0.4;
    pointer-events: none;
  }

  &__link {
    @include remove-text-decoration($body-color);

    display: flex;
    flex: 1;
    font-size: 14px;

    &--content {
      display: flex;
      gap: 12px;

      .custom-control-label {
        @include media-breakpoint-up(xl) {
          background-color: $grey-200;
        }
      }
    }

    &--label {
      display: flex;
      transform: translateY(2px);
      gap: 4px;
    }

    .text-muted {
      color: #b7c1c9;
    }

    &.disabled {
      opacity: 0.4;
    }
  }

  &__image {
    mix-blend-mode: multiply;
  }

  &__tooltip {
    color: #b7c1c9;
  }
}

a.disabled {
  pointer-events: none;
}
</style>
